///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { ChangeDetectionStrategy, Component, ElementRef, Input, Renderer2 } from '@angular/core';

@Component({
    selector: 'winde-password-strength-bar',
    template: ` <div id="strength">
        <small>{{ 'global.messages.validate.newpassword.strength' | translate }}</small>
        <ul id="strengthBar">
            <li class="point"></li>
            <li class="point"></li>
            <li class="point"></li>
            <li class="point"></li>
        </ul>
    </div>`,
    styleUrls: ['password-strength-bar.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PasswordStrengthBarComponent {
    colors = ['#F00', '#F90', '#FF0', '#9F0', '#0F0'];

    constructor(
        private readonly renderer: Renderer2,
        private readonly elementRef: ElementRef
    ) {}

    @Input()
    set passwordToCheck(password: string) {
        if (password) {
            let passwordStrength = Math.round(this.measureStrength(password));
            passwordStrength = passwordStrength > 4 ? 4 : passwordStrength;
            const c = { idx: passwordStrength, col: this.colors[passwordStrength] };
            const element = this.elementRef.nativeElement;
            if (element.className) {
                this.renderer.removeClass(element, element.className);
            }
            const lis = element.getElementsByTagName('li');
            for (let i = 0; i < lis.length; i++) {
                if (i < c.idx) {
                    this.renderer.setStyle(lis[i], 'backgroundColor', c.col);
                } else {
                    this.renderer.setStyle(lis[i], 'backgroundColor', '#DDD');
                }
            }
        } else {
            const lis = this.elementRef.nativeElement.getElementsByTagName('li');
            for (const el of lis) {
                this.renderer.setAttribute(el, 'style', '');
            }
        }
    }

    measureStrength(p: string): number {
        let force = 0;
        const regex = /[$-/:-?{-~!"^_`[\]]/g; // "

        const lowerLetters = /[a-z]+/.test(p);
        const upperLetters = /[A-Z]+/.test(p);
        const numbers = /\d+/.test(p);
        const symbols = regex.test(p);

        const flags = [lowerLetters, upperLetters, numbers, symbols];
        const passedMatches = flags.filter((isMatchedFlag: boolean) => {
            return isMatchedFlag === true;
        }).length;

        force += 2 * p.length + (p.length >= 10 ? 1 : 0);
        force += passedMatches * 10;

        // penality (short password)
        force = p.length <= 6 ? Math.min(force, 10) : force;

        // penality (poor variety of characters)
        force = passedMatches === 1 ? Math.min(force, 10) : force;
        force = passedMatches === 2 ? Math.min(force, 20) : force;
        force = passedMatches === 3 ? Math.min(force, 30) : force;
        force = passedMatches === 4 ? Math.min(force, 40) : force;

        return force;
    }
}
